<template>
    <div class="foot">
        <div class="wrapper bottom">
            <div class="foot-left">
                <img src="../../../static/images/bot_logo.png"/>
                <p>电话：18601342599、18600241699 </p>
                <p>地址：北京海淀区国悦府中厅8222室 邮箱：xiaolujiaoapp@chinambn.com</p>
                <p>© 北京诗焓文化 版权所有  增值电信业务经营许可证: <a target="_blank" href="https://beian.miit.gov.cn/?spm=5176.28508143.J_9220772140.60.1356154aqivS2a#/Integrated/index">京B2-20240200</a>  域名注册服务机构许可: <a target="_blank" href="https://beian.miit.gov.cn/?spm=5176.28508143.J_9220772140.60.1356154aqivS2a#/Integrated/index">京ICP备14034174号-9</a></p>
            </div>
            <div class="foot-right">
                <div>
                    <img src="../../../static/images/code/music_web.jpeg" />
                    <span>音乐财经公众号</span>
                </div>
                <div>
                    <img src="../../../static/images/code/app_web.png" />
                    <span>小鹿角APP公众号</span>
                </div>
<!--                <div>-->
<!--                    <img src="../../../static/images/code/app.jpeg" />-->
<!--                    <span>小鹿角APP</span>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "foot-menu",
        data(){
            return{
            }
        },
        methods:{

        }
    }
</script>

<style scoped lang="less">
    .foot {
        width: 100%;
        padding: 28px 0 40px;
        background: #333333;
        .bottom {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            .foot-left {
                font-size: 12px;
                line-height: 25px;
                color: #CCCCCC;
                margin-top: 16px;
                img {
                    display: block;
                    width: 100px;
                    height: 33px;
                    margin-bottom: 16px;
                }
                a {
                    color: #CCCCCC;
                }
            }
            .foot-right {
                display: flex;
                flex-direction: row;
                margin-top: 16px;
                div {
                    margin-left: 20px;
                    img {
                        width: 100px;
                        height: 100px;
                    }
                    span {
                        display: block;
                        text-align: center;
                        margin-top: 4px;
                        color: #ffffff;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue